const appId = 'wider-web';
const appName = 'riderapp';
const clientId = 'f3b17ba3-7d5d-4c30-ba63-5fe137acb243';
const clientSecret = 'pass';
const locales = ['en', 'es'];

const baseUrl = 'https://mobility-app-east.transitsherpa.com/rider/graphql/';
const scope = 'sunrail-prod';
const processor = 'nic';
const googleAnalyticsId = 'G-NYWLPDPPEG';
const reCaptchaSiteKey = '6LdKPyYUAAAAAOvis88qcmnaazGowUgPMuTCwMT6';
const communicationPref = false;
const dualAuth = false;
const promotions = false;
const autoReplenish = true;
const ONE_TIME_PAYMENT_DURATION = 15 * 60 * 1000;
const oneTimePayment = true;
const riderTypeSelect = true;
const migration = true;
const fareCapping = false;
const registrationFields = {
  name: 'optional',
  mobile: 'optional',
  address: 'optional',
  city: 'optional',
  state: 'optional',
  zipCode: 'optional'
};

export {
  appId,
  appName,
  clientId,
  clientSecret,
  locales,
  baseUrl,
  scope,
  processor,
  googleAnalyticsId,
  reCaptchaSiteKey,
  communicationPref,
  dualAuth,
  promotions,
  autoReplenish,
  ONE_TIME_PAYMENT_DURATION,
  oneTimePayment,
  riderTypeSelect,
  migration,
  fareCapping,
  registrationFields
};
